<template>
  <div class="detail">
    <div class="banner">
      <img :src="magazine.titleUrl" alt />
    </div>
    <div class="navBox">
      <div class="nav">
        <div class="caption">{{ magazine.title }}</div>
        <div class="about">
          <!-- <span class="author">作者：{{ magazine.author }}</span> -->
          <span class="release">发布时间：{{ magazine.createTime }}</span>
        </div>
        <div class="browse">
          <span class="read">{{ magazine.pageview }}次阅读</span>
          <!-- <span class="support">{{ magazine.subscription }}个赞</span> -->
        </div>
      </div>
    </div>
    <div class="contentBox">
      <div class="content">
        <div class="information" v-html="magazine.content"></div>
        <!-- <div class="select">*文章转自壹点灵，若有侵权，版权个人或单位不想本网发布，可联系作者或本站，我们将立即将其撤除</div> -->
        <div class="relate">
          <img src="../../assets/sign.png" alt />
          <span style="font-size: 16px; font-weight: 600; color: #333"
            >相关案例</span
          >
        </div>
      </div>
    </div>
    <div class="referBox">
      <div
        @click="getMagazineDetail(item.id)"
        class="refer"
        v-for="item in list"
        :key="item.id"
      >
        <div class="photo">
          <img :src="item.titleUrl" alt />
        </div>
        <div class="message">
          <span class="title">{{ item.title }}</span>
          <span class="detail">{{ item.content }}</span>
          <span class="people">阅读：{{ item.pageview }}</span>
        </div>
      </div>
    </div>
    <div class="footer" style="margin-top: 60px"></div>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import { getArticles, getActivity } from "@/api/system/articles";
export default {
  name: "detail",
  data() {
    return {
      type: 0,
      magazine: {},
      list: [],
    };
  },
  methods: {
    getDetail() {
      getActivity(this.$route.params.id).then((res) => {
        this.magazine = res.data;
        this.list = res.data.otherActivityNews;
      });
    },
    getMagazineDetail(id) {
      this.miniJump(`/detail?id=${id}`)
      this.getDetail();
    },
  },
  created() {
    this.getDetail();
    if (this.$route.query.type == 0) {
      this.type = 0;
    } else if (this.$route.query.type == 1) {
      this.type = 1;
    }
  },
  updated() {
    window.scroll(0, 0);
  },
};
</script>

<style lang="scss">
.detail {
  .mind_top {
    background: #577eff !important;
    z-index: 99;
  }
  .banner {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .navBox {
    display: flex;
    justify-content: center;
    .nav {
      width: 90%;
      display: flex;
      flex-direction: column;
      background: #fff;
      box-shadow: 0 10px 10px rgb(227, 245, 253);
      margin-top: -50px;
      border-radius: 8px;
      .caption {
        font-size: 15px;
        color: #333;
        font-weight: 600;
        margin: 15px;
      }
      .about {
        margin: 0px 15px 10px;
        .release {
          font-size: 14px;
          color: #333;
        }
      }
      .browse {
        margin: 0px 15px 15px;
        .read {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
  .contentBox {
    display: flex;
    justify-content: center;
    .content {
      width: 90%;
      display: flex;
      flex-direction: column;
      margin-top: 25px;
      line-height: 25px;
      img {
        max-width: 100%;
      }
      .select {
        margin: 20px 0;
        line-height: 22px;
      }
      .relate {
        display: flex;
        img {
          width: 8.5px;
          height: 22px;
          margin: 0 10px 0 0;
        }
      }
    }
  }
  .referBox {
    width: 100%;
    margin-top: 10px;
    background: #fff;
    .refer {
      width: 100%;
      margin: 20px 0;
      display: flex;
      .photo {
        margin: 0 20px;
        width: 102px;
        height: 80px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .message {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .title {
          color: rgb(51, 51, 51);
          font-weight: 600;
          width: 220px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .detail {
          margin: 10px 0;
          width: 220px;
          text-align: start;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: #666;
        }
        .people {
          margin-top: 3px;
          color: #999;
        }
      }
    }
  }
}
</style>